<template>
	<div>
		<v-layout class="py-2">
			<div class="listing-heading">Quotation</div>
			<v-spacer></v-spacer>
			<v-btn color="grey lighten-3" tile depressed class="mx-3" @click="goBack()">
				<v-icon small left>mdi-arrow-left</v-icon>
				Back
			</v-btn>
		</v-layout>
		<div>
			<ModuleSettings type="quotation" title="quotation"></ModuleSettings>
		</div>
		<div class="mt-5">
			<TermsAndConditions module="quotation"></TermsAndConditions>
		</div>
	</div>
</template>
<script>
import ModuleSettings from "@/view/components/ModuleSettings";
import TermsAndConditions from "@/view/module/setting/pages/TermsAndConditions";
export default {
	name: "Quotation",
	data() {
		return {
			remark: null,
			pageLoading: null,
		};
	},
	components: {
		ModuleSettings,
		TermsAndConditions,
	},
};
</script>
